<template>
    <div>
        <!-- IF REPORT IS GENERATING -->
        <div v-if="loading_downloading_report" class="download-loading-prompt-sec fixed py-1 pr-6 pl-2 text-white"
            style="left: 85px; z-index: 99999999;" :style="[downloading_report_is_ready ? {bottom: '85px'} : {bottom: '15px'}]">
            <span class="flex items-center">
                <svg style="width:50px" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100"
                    enable-background="new 0 0 0 0" xml:space="preserve">
                    <path fill="#fff"
                        d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                        <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s"
                            from="0 50 50" to="360 50 50" repeatCount="indefinite" />
                    </path>
                </svg>
                <p>{{ 'Generating ' + downloading_report_count + (downloading_report_count > 1 ? ( ' ' + downloading_report_title) : ( ' ' + downloading_report_title + 's')) + ' in background ' }}</p>
            </span>
        </div>
        <!-- IF REPORT IS READY -->
        <div v-if="downloading_report_is_ready" class="download-loading-prompt-sec fixed py-3 pr-6 pl-2 text-white"
            style="bottom: 15px; left: 85px; z-index: 99999999;">
            <span class="flex items-center">
                <img class="mx-4 my-2" src="../../assets/icons/file-downloaded.svg" alt="Done" width="20px" srcset="">
                <p>{{ downloading_report_title + ' Generated Successfully' }}</p>
                <i class="el-icon-close pl-2 cursor-pointer" @click="closePrompt"></i>
            </span>
        </div>
    </div>
</template>
 
<script>
import { mapState } from "vuex";
export default {
    name: 'DownloadLoadingPrompt',
    props: {

    },
    data() {
        return {
            mtd: true,
        }
    },
    computed: {
        ...mapState("CommonStore", ["loading_downloading_report", "downloading_report_count", "downloading_report_is_ready", "downloading_report_title"])
    },
    created() {

    },
    mounted() {

    },
    methods: {
        closePrompt(){
            this.$store.commit( 'CommonStore/SET_DOWNLOADING_REPORT_CLOSE');
        }
    },
}
</script>

<style lang="scss" scoped>
.download-loading-prompt-sec {
    background-color: #2e323a;
}
</style>